export const ROUTE_HOME = '/';
export const ROUTE_LOGIN = '/login';
export const ROUTE_FORGOT_PASSWORD = '/forgot-password';
export const SSO_CUSTOMER_ID_QUERY_PARAM = 'customerId';
export const SSO_CUSTOMER_ID_STORAGE_KEY = 'ssoCustomerId';

export const TERMS_URL = 'https://www.mesh.id/terms-of-service';
export const PRIVACY_POLICY_URL = 'https://www.mesh.id/privacy-statement';
export const COOKIE_POLICY_URL = 'https://www.mesh.id/cookie-policy';
export const TALK_TO_SALES_URL = 'mailto:sales@mesh.id';
export const SUPPORT_EMAIL = 'support@mesh.id';

export const DEFAULT_SIGN_IN_ERROR_MESSAGE = 'Sign in failed. Please try again.';
export const ADDITIONAL_STEP_ERROR_MESSAGE = (step) => `Additional step required: ${step}`;

export const LOGIN_TITLE = 'Sign in to your account';
export const LOGIN_EMAIL_LABEL = 'Email';
export const LOGIN_PASSWORD_LABEL = 'Password';
export const LOGIN_EMAIL_PLACEHOLDER = 'you@company.com';
export const LOGIN_PASSWORD_PLACEHOLDER = '••••••••';
export const LOGIN_BUTTON_LABEL = 'Sign in';
export const LOGIN_BUTTON_LOADING = 'Signing in…';
export const SSO_BUTTON_LOADING = 'Redirecting…';
export const FORGOT_PASSWORD_LABEL = 'Forgot your password?';

export const TERMS_INTRO = 'By continuing, I agree to Mesh';
export const TERMS_LINK_LABEL = 'terms';
export const PRIVACY_POLICY_LINK_LABEL = 'privacy policy';
export const COOKIE_LINK_LABEL = 'cookie policy';
export const TALK_TO_SALES_PROMPT = 'Don’t have an account?';
export const TALK_TO_SALES_LABEL = 'Talk to sales';

export const FORGOT_HEADING_FORGOT = 'Forgot your password?';
export const FORGOT_HEADING_RESET = 'Reset your password';
export const FORGOT_HEADING_DONE = 'Password reset';
export const FORGOT_BODY_FORGOT =
  'Enter the email address you use to sign in and we’ll send you a reset code.';
export const FORGOT_SUCCESS_SEND_CODE = 'Check your email for a reset code.';
export const FORGOT_SUCCESS_RESET_DONE = 'Password reset. You can now log in.';
export const FORGOT_ERROR_SEND_CODE = 'Failed to send reset code. Please try again.';
export const FORGOT_ERROR_RESET = 'Failed to reset password. Please try again.';
export const FORGOT_ERROR_PASSWORDS_MISMATCH = 'Passwords do not match.';
export const FORGOT_ERROR_PASSWORD_MIN_LENGTH = 'Password must be at least 8 characters.';
export const FORGOT_BACK_TO_LOGIN = 'Back to Sign in';
export const FORGOT_BUTTON_SEND_CODE = 'Send reset code';
export const FORGOT_BUTTON_SEND_LOADING = 'Sending…';
export const FORGOT_BUTTON_RESET = 'Reset password';
export const FORGOT_BUTTON_RESET_LOADING = 'Resetting…';
export const FORGOT_RESET_CODE_LABEL = 'Reset code';
export const FORGOT_RESET_CODE_PLACEHOLDER = 'Enter the code from your email';
export const FORGOT_NEW_PASSWORD_LABEL = 'New password';
export const FORGOT_CONFIRM_PASSWORD_LABEL = 'Confirm new password';
